import RejectReasonTable from './RejectReasonTable'

export default RejectReasonTable
